import ptBR from 'date-fns/locale/pt-BR'
import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'
import formatRelative from 'date-fns/formatRelative'
import isToday from 'date-fns/isToday'
import isYesterday from 'date-fns/isYesterday'

import { getMobileVersion } from '@/utils/mobile'
import { formatToBRL } from '@inter/lib-util'

export interface Informations {
  scoreStatus: string
  scoreValue: string
  scoreTag: string
}
const customRelativeLocale: LocalePtBR = {
  lastWeek: 'dd/MM/yyyy',
  yesterday: "'Ontem'",
  today: "'Hoje'",
  tomorrow: "'Amanhã'",
  nextWeek: "'Próxima Semana'",
  other: 'dd/MM/yyyy',
}

const locale = {
  ...ptBR,
  formatRelative: (token: LocaleProps) => customRelativeLocale[token],
}

export const getDateExtended = (date: Date) =>
  isToday(date) || isYesterday(date)
    ? formatRelative(date, new Date(), { locale })
    : format(date, "EEEE, dd 'de' LLLL", { locale })

export const getMonthExtended = (date: Date) => {
  const extendedMonth: string = format(date, 'LLLL', { locale })
  return extendedMonth
}

export const formatHour = (value: Date) =>
  new Intl.DateTimeFormat('pt-BR', {
    hour: 'numeric',
    minute: 'numeric',
  }).format(new Date(value))

export const formatDate = (value: Date) =>
  new Intl.DateTimeFormat('pt-BR', {
    weekday: 'long',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date(value))

export const formatDates = (date: string | Date | number, pattern = 'dd/MM/yyyy'): string => {
  const parsedDate = typeof date === 'string' ? parseISO(date) : date

  return format(parsedDate, pattern)
}

export const getBrazilianFormatWithHour = (date: Date) =>
  format(date, 'dd/MM/yyyy, HH:mm', { locale })

export const getBrazilianFormat = (date: Date) => format(date, 'dd/MM/yyyy', { locale })

export const isUnder18 = (birthDateTimestamp: number): boolean => {
  const birthDate = new Date(birthDateTimestamp)
  const today = new Date()
  let age = today.getFullYear() - birthDate.getFullYear()
  const monthDiff = today.getMonth() - birthDate.getMonth()

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age -= 1
  }

  return age < 18
}

export const ageCalculator = (date: string) => {
  const partOfAge = new Date()
  const currentYear = partOfAge.getFullYear()
  const currentMonth = partOfAge.getMonth() + 1
  const currentDay = partOfAge.getDate()
  const split = date.split('/')
  const newDate = `${split[1]}/${split[0]}/${split[2]}`
  const americanDate = new Date(newDate)
  const year = americanDate.getFullYear()
  const month = americanDate.getMonth() + 1
  const day = americanDate.getDate()
  const birthdayYear = +year
  const birthdayMonth = +month
  const birthdayDay = +day
  let howOld = currentYear - birthdayYear
  if (
    currentMonth < birthdayMonth ||
    (currentMonth === birthdayMonth && currentDay < birthdayDay)
  ) {
    howOld -= 1
  }
  return howOld < 0 ? 0 : howOld
}

export const formatFieldWithoutValue = (incomeValue: string, version?: string, eye?: boolean) => {
  if (version && getMobileVersion(version)) {
    if (eye) {
      return incomeValue
    }
    return '•••••'
  }
  return incomeValue
}
export const formatFieldWithValue = (incomeValue: number, version?: string, eye?: boolean) => {
  if (version && getMobileVersion(version)) {
    if (eye) {
      return formatToBRL(incomeValue)
    }
    return 'R$ •••••'
  }
  return formatToBRL(incomeValue)
}
export const formatFieldWithValueAndId = (
  incomeValue?: string,
  version?: string,
  eye?: boolean,
  id?: string,
) => {
  if (version && getMobileVersion(version) && id === 'profile-item-2') {
    if (eye) {
      return incomeValue
    }
    return 'R$ •••••'
  }
  return incomeValue
}
